import { notification } from "antd";
import { defineMessages } from "react-intl";

import TourDescriptor from "@app/component/flows/types/TourDescriptor";

const title = defineMessages({
  step1: {
    id: "guides.mapOnboarding.leadFinder.step1",
    defaultMessage: "Introduction to Lead Finder",
  },
  step2: {
    id: "guides.mapOnboarding.leadFinder.step2",
    defaultMessage: "Make your search",
  },
  step3: {
    id: "guides.mapOnboarding.leadFinder.step3",
    defaultMessage: "See the results!",
  },
  step4: {
    id: "guides.mapOnboarding.leadFinder.step4",
    defaultMessage: "One last step",
  },
});

const description = defineMessages({
  step1: {
    id: "guides.mapOnboarding.leadFinder.step1.description",
    defaultMessage: "First, start by opening Lead Finder 🕵️",
  },
  step2: {
    id: "guides.mapOnboarding.leadFinder.step2.description",
    defaultMessage:
      "Here, you can customize <b>where</b> and <b>what</b> you're searching for.{br}1️⃣ Search for a keyword (e.g. 'Hospital'){br}2️⃣ By default, Lead Finder searches near your <b>current map view</b>. Click the dropdown to see what other locations you can search by.{br}Then, click <b>Go</b> to make your search.",
  },
  step3: {
    id: "guides.mapOnboarding.leadFinder.step3.description",
    defaultMessage:
      "👉 Here is where you would select leads that you want to add to your Company or People records.",
  },
  step4: {
    id: "guides.mapOnboarding.leadFinder.step4.description",
    defaultMessage: "Add records to the map and/or existing routes by clicking here!",
  },
});

export const leadFinderTour: TourDescriptor = {
  id: "map-onboarding-lead-finder",
  steps: [
    {
      id: "lead-finder-button",
      description: description.step1,
      onBefore: async () => {
        notification.destroy();
      },
      options: {
        disableInteraction: false,
        showButtons: false,
      },
      selector: "button[class*=LeadFinderButton]",
      title: title.step1,
      waitForEvent: {
        eventType: "click",
        selector: "button[class*=LeadFinderButton]",
      },
    },
    {
      id: "lead-finder-search",
      description: description.step2,
      options: {
        disableInteraction: false,
        expectRouteChange: true,
        showButtons: false,
      },
      selector: "div[class*=SearchPopover]",
      title: title.step2,
      waitForEvent: {
        eventType: "internal",
        selector: "Process: Map -> Lead Finder mode",
      },
    },
    {
      id: "lead-finder-results",
      description: description.step3,
      selector: "[class*=Sidebar_container] .ant-drawer-content",
      title: title.step3,
    },
    {
      id: "lead-finder-records-button",
      description: description.step4,
      selector: "[class*=ResultsPane_selection] .mmc-button--primary",
      title: title.step4,
    },
  ],
};
